var map = {
	"./template.bet575": 1924,
	"./template.bet575.tsx": 1924,
	"./template.bet777": 1925,
	"./template.bet777.tsx": 1925,
	"./template.betgalaxy": 1926,
	"./template.betgalaxy.tsx": 1926,
	"./template.betprofessor": 1927,
	"./template.betprofessor.tsx": 1927,
	"./template.betroyale": 2033,
	"./template.betroyale.tsx": 2033,
	"./template.betstride": 1928,
	"./template.betstride.tsx": 1928,
	"./template.buffalobet": 1929,
	"./template.buffalobet.tsx": 1929,
	"./template.chromabet": 1930,
	"./template.chromabet.tsx": 1930,
	"./template.default": 183,
	"./template.default.tsx": 183,
	"./template.epicodds": 1931,
	"./template.epicodds.tsx": 1931,
	"./template.fiestabet": 1932,
	"./template.fiestabet.tsx": 1932,
	"./template.forsport": 2150,
	"./template.forsport.tsx": 2150,
	"./template.gigabet": 1933,
	"./template.gigabet.tsx": 1933,
	"./template.goldenbet888": 1934,
	"./template.goldenbet888.tsx": 1934,
	"./template.goldenrush": 1935,
	"./template.goldenrush.tsx": 1935,
	"./template.hyperbet": 1936,
	"./template.hyperbet.tsx": 1936,
	"./template.juicybet": 1937,
	"./template.juicybet.tsx": 1937,
	"./template.junglebet": 1938,
	"./template.junglebet.tsx": 1938,
	"./template.magnumbet": 1939,
	"./template.magnumbet.tsx": 1939,
	"./template.puntcity": 2151,
	"./template.puntcity.tsx": 2151,
	"./template.puntgenie": 1940,
	"./template.puntgenie.tsx": 1940,
	"./template.pyramidbet": 1941,
	"./template.pyramidbet.tsx": 1941,
	"./template.questbet": 1942,
	"./template.questbet.tsx": 1942,
	"./template.slambet": 1943,
	"./template.slambet.tsx": 1943,
	"./template.sterlingparker": 1944,
	"./template.sterlingparker.tsx": 1944,
	"./template.templebet": 1945,
	"./template.templebet.tsx": 1945,
	"./template.titanbet": 1946,
	"./template.titanbet.tsx": 1946,
	"./template.ts": 1001,
	"./template.vikingbet": 1947,
	"./template.vikingbet.tsx": 1947,
	"./template.volcanobet": 1948,
	"./template.volcanobet.tsx": 1948,
	"./template.wellbet": 2152,
	"./template.wellbet.tsx": 2152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2795;